module.exports = __webpack_public_path__ + "media/images/lb/357-9dbca7a90fb964c6b0244f0fcea3c984.svg";